import user from "./user/user.reducers";
import chat from "./chat/chat.reducers";
import branding from "./branding/branding.reducers";
import userProfile from "./userProfile/userProfile.reducers";
import pets from "./pets/pets.reducers";
import credits from "./credits/credits.reducers";
import scheduleAppointment from "./scheduleAppointment/scheduling.reducers";
import appointmentList from "./appointmentList/appointmentList.reducers";
import appointment from "./appointment/appointment.reducers";
import images from "./images/images.reducers";
import common from "./common/common.reducers";

export default {
    user,
    chat,
    branding,
    userProfile,
    pets,
    credits,
    scheduleAppointment,
    appointmentList,
    appointment,
    images,
    common,
};
